// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13270(7cf0455276)-C13/10/2026-08:43:44-B13/10/2026-08:53:47' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13270(7cf0455276)-C13/10/2026-08:43:44-B13/10/2026-08:53:47",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13270",
  shortHash: "7cf0455276",
  longHash: "7cf04552769f0f6660abbc009b60e9cd7f455e63",
  dateCommit: "13/10/2026-08:43:44",
  dateBuild: "13/10/2026-08:53:47",
  buildType: "Ansible",
  } ;
